/**
 * WHAT: Security configuration for session inactivity timeout and auto-logout behavior.
 * WHY:  DAMA handles sensitive database access data; unattended sessions must be automatically
 *       terminated to reduce the risk of unauthorized access. This config centralizes the
 *       timeout duration, warning period, and monitored user-activity events.
 */

const SECURITY_CONFIG = {
  // Inactivity timeout in milliseconds (10 minutes = 600000ms)
  INACTIVITY_TIMEOUT: 10 * 60 * 1000,

  // Warning shown before logout (1 minute before timeout)
  WARNING_BEFORE_LOGOUT: 1 * 60 * 1000,

  // Events that reset the inactivity timer
  ACTIVITY_EVENTS: ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']
};

export default SECURITY_CONFIG;
